import type { TranslationDict } from "@repo/core";

export const pt: TranslationDict = {
  // —— uiKeys ——
  "type.income": "Receita",
  "type.expense": "Despesa",
  "type.transfer": "Transferência",

  "person.household": "Lar",
  "person.personal": "Pessoal",
  "person.partner": "Parceiro",
  "person.sideHustle": "Renda extra",

  "method.snowball": "Bola de neve",
  "method.avalanche": "Avalanche",

  "tx.log": "Registro de transações",
  "tx.search": "Buscar…",
  "tx.allTypes": "Todos os tipos",
  "tx.allCategories": "Todas as categorias",
  "tx.fromDate": "Data inicial",
  "tx.toDate": "Data final",
  "tx.minAmount": "Mín",
  "tx.maxAmount": "Máx",
  "tx.clearFilters": "Limpar",
  "tx.entries": "{n} lançamentos",
  "tx.noMatch": "Nenhuma transação corresponde aos filtros.",
  "tx.loadMore": "Carregar mais ({n} restantes)",
  "tx.importCsv": "Importar CSV",
  "tx.csv": "CSV",
  "tx.add": "Adicionar",
  "tx.edit": "Editar",
  "tx.delete": "Excluir",
  "tx.editAria": "Editar transação",
  "tx.deleteAria": "Excluir transação",
  "tx.deleteConfirm": "Excluir esta transação?",
  "tx.col.date": "Data",
  "tx.col.type": "Tipo",
  "tx.col.amount": "Valor",
  "tx.col.category": "Categoria",
  "tx.col.account": "Conta",
  "tx.col.person": "Pessoa",
  "tx.col.notes": "Notas",
  "tx.account": "Conta",
  "tx.category": "Categoria",
  "tx.chooseAccount": "— Escolher conta —",

  "txModal.edit": "Editar transação",
  "txModal.new": "Nova transação",
  "txModal.editSub": "Atualizar um lançamento existente",
  "txModal.newSub": "Registrar gasto ou receita",
  "txModal.type": "Tipo de transação",
  "txModal.amount": "Valor",
  "txModal.date": "Data",
  "txModal.person": "Pessoa / Membro",
  "txModal.personPh": "Lar, João, Ana…",
  "txModal.category": "Categoria",
  "txModal.chooseCategory": "— Escolher categoria —",
  "txModal.notes": "Notas / Descrição",
  "txModal.notesPh": "Detalhes opcionais…",
  "txModal.recurring": "Transação recorrente",
  "txModal.freq.weekly": "Semanal",
  "txModal.freq.monthly": "Mensal",
  "txModal.freq.custom": "Intervalo personalizado",
  "txModal.intervalDays": "Dias entre cada",
  "txModal.recurringHelp":
    "Lançamentos futuros são gerados automaticamente. Você pode pular uma ocorrência depois.",
  "txModal.series": "Série recorrente",
  "txModal.scopeOne": "Somente esta ocorrência",
  "txModal.scopeSeries": "Série inteira (esta e futuras)",
  "txModal.skip": "Pular esta ocorrência",
  "txModal.skipConfirm":
    "Pular só esta ocorrência? O restante da série permanece.",
  "txModal.saving": "Salvando…",
  "txModal.update": "Atualizar transação",
  "txModal.save": "Salvar transação",

  "csv.title": "Importar CSV",
  "csv.intro":
    "Mapeie as colunas do extrato bancário, visualize as linhas e depois importe.",
  "csv.mapping": "Mapeamento de colunas",
  "csv.mappingHint":
    "Esquerda: nome da coluna no seu CSV. Direita: atribua cada uma a um campo do BudgetOS.",
  "csv.preview": "Pré-visualização ({ok}/{total} válidas)",
  "csv.ignore": "Ignorar",
  "csv.ok": "OK",
  "csv.importing": "Importando…",
  "csv.importN": "Importar {n} linhas",
  "csv.readError": "Não foi possível ler os cabeçalhos do CSV.",
  "csv.badDate": "Data inválida",
  "csv.badAmount": "Valor inválido",
  "csv.noCategory": "Sem categoria",
  "csv.needAccount":
    "Adicione sua primeira conta em Configurações antes de importar — as linhas do CSV precisam de uma conta.",

  "cal.subtitle": "Acompanhe gastos diários e sequências sem gastar",
  "cal.prev": "Mês anterior",
  "cal.next": "Próximo mês",
  "cal.streak": "Sequência sem gastar",
  "cal.streakSub": "dias consecutivos",
  "cal.noSpendDays": "Dias sem gasto",
  "cal.thisMonth": "este mês",
  "cal.spendDays": "Dias com gasto",
  "cal.active": "ativos",
  "cal.totalSpent": "Total gasto",
  "cal.avgDay": "média {amount}/dia",
  "cal.title": "Calendário de gastos (clique no dia para detalhes)",
  "cal.legend.noSpend": "Sem gasto",
  "cal.legend.spend": "Dia com gasto",
  "cal.legend.today": "Hoje",
  "cal.badge.noSpend": "Dia sem gasto",
  "cal.badge.spent": "Gasto:",
  "cal.badge.income": "Receita:",
  "cal.cleanTitle": "Sequência financeira limpa!",
  "cal.cleanBody": "Nenhum gasto registrado neste dia. Continue assim!",
  "cal.txOnDate": "Transações nesta data ({n})",
  "cal.addForDate": "Adicionar transação nesta data",

  "debt.title": "Calculadora de quitação de dívidas",
  "debt.totalDebt": "Dívida total",
  "debt.totalInterest": "Juros totais",
  "debt.debtFreeDate": "Data livre de dívidas",
  "debt.apr": "{n}% a.a.",
  "debt.currentBalance": "saldo atual",
  "debt.minPay": "Pgto. mín.",
  "debt.extra": "Extra",
  "debt.interest": "Juros",
  "debt.months": "{n} meses",
  "debt.viewSchedule": "Ver tabela de amortização completa",
  "debt.hideSchedule": "Ocultar tabela de amortização",
  "debt.col.month": "Mês",
  "debt.col.payment": "Pagamento",
  "debt.col.principal": "Principal",
  "debt.col.interest": "Juros",
  "debt.col.balance": "Saldo",
  "debt.balance": "Saldo ({symbol})",
  "debt.rate": "Taxa (%)",
  "debt.minPayment": "Pagamento mínimo",
  "debt.extraPayment": "Pagamento extra",
  "debt.chartTitle": "Saldo combinado das dívidas ao longo do tempo",
  "debt.payoffOrderSnowball": "Ordem de quitação (menor saldo primeiro)",
  "debt.payoffOrderAvalanche": "Ordem de quitação (maior taxa primeiro)",
  "debt.exportSchedule": "Exportar tabela",
  "debt.edit": "Editar",

  "mb.exportMonth": "Exportar este mês",
  "mb.income": "Receitas",
  "mb.expenses": "Despesas",
  "mb.target": "meta {amount}",
  "mb.budget": "orçamento {amount}",
  "mb.allocation": "Alocação mensal de gastos",
  "mb.byGroup": "Por grupo (Necessidades / Desejos / Poupança)",
  "mb.topExpense": "Principais categorias de despesa",
  "mb.incomeSources": "Fontes de receita",

  "rule.netIncome": "Renda líquida mensal",
  "rule.distribution": "Distribuição 50/30/20",
  "rule.breakdown": "Detalhamento",
  "rule.visual": "Comparação visual",
  "rule.targetPct": "Meta: {n}% da renda",
  "rule.actual": "Real:",
  "rule.unclassified": "{n}% da renda sem classificar ou sem gastar",
  "rule.status.ahead": "Acima da meta",
  "rule.status.onTrack": "No caminho",
  "rule.status.below": "Abaixo da meta",
  "rule.status.over": "Acima do orçamento",
  "rule.status.under": "Abaixo da meta",

  "sf.title": "Fundos objetivo",
  "sf.addFund": "Adicionar fundo",
  "sf.totalSaved": "Total poupado",
  "sf.saved": "Poupado",
  "sf.target": "Meta",
  "sf.remaining": "Restante",
  "sf.monthsLeft": "Meses restantes",
  "sf.needMonth": "Precisa/mês",
  "sf.contribute": "+ Contribuir",
  "sf.contributePrompt": "Adicionar a \"{name}\"\nAtual: {current}\nValor:",
  "sf.deleteConfirm": "Excluir \"{name}\"?",
  "sf.due": "Vence {date}",
  "sf.newTitle": "Novo fundo objetivo",
  "sf.name": "Nome",
  "sf.icon": "Ícone",
  "sf.namePh": "ex. Férias",
  "sf.fundIcon": "Ícone do fundo",
  "sf.targetAmount": "Meta",
  "sf.targetDate": "Data da meta",
  "sf.alreadySaved": "Já poupado",
  "sf.color": "Cor",
  "sf.empty": "Ainda não há fundos. Adicione um para começar a poupar!",

  "cf.title": "Fluxo de caixa mensal",
  "cf.titleYear": "Fluxo de caixa mensal · {year}",
  "cf.netSurplus": "Superávit líquido",
  "cf.income": "Receitas",
  "cf.expenses": "Despesas",
  "cf.expense": "Despesa",
  "cf.netFlow": "Fluxo líquido",
  "cf.pctSaved": "{n}% poupado",
  "cf.mode.bars": "Barras agrupadas",
  "cf.mode.flow": "Fluxo suave",
  "cf.mode.net": "Superávit líquido",
  "cf.avgIncome": "Receita média",
  "cf.avgExpenses": "Despesa média",
  "cf.avgNet": "Superávit médio",
  "cf.perMo": "/mês",
  "cf.peak": "Pico: {month} ({amount})",
  "cf.maxExp": "Máx. desp.: {month} ({amount})",
  "cf.png": "PNG",

  "settings.dataMgmt": "Gestão e verificação de dados",
  "settings.backupTitle": "Backup e restauração",
  "settings.backupDesc":
    "Baixe um backup JSON de todos os dados locais ou restaure de uma exportação anterior.",
  "settings.pdfTitle": "Relatório anual em PDF",
  "settings.pdfDesc":
    "PDF offline sob medida: capa, KPIs, fluxo de caixa, orçamento, 50/30/20, dívidas, fundos e patrimônio — com gráficos embutidos.",
  "settings.currencyLocale": "Moeda e região",
  "settings.theme": "Tema",
  "settings.helpSection": "Ajuda",
  "settings.openFaq": "Abrir FAQ",
  "settings.currency": "Moeda",
  "settings.preview": "Pré-visualização",
  "settings.negative": "Negativo:",
  "settings.compact": "Compacto:",
  "settings.footer": "BudgetOS · Todos os dados ficam armazenados localmente neste dispositivo.",
  "settings.deleteCategory":
    "Excluir esta categoria? As transações mantêm os valores, mas perdem o vínculo.",
  "settings.deleteAccount": "Excluir esta conta?",
  "settings.noCategories": "Ainda não há categorias — adicione uma acima.",
  "settings.icon": "Ícone",
  "settings.name": "Nome",
  "settings.monthlyTarget": "Meta mensal",
  "settings.group": "Grupo",
  "settings.accountNameLabel": "Nome da conta",
  "settings.openingBalance": "Saldo inicial",
  "settings.type": "Tipo",
  "settings.perMonth": "{amount}/mês",
  "settings.categoryIcon": "Ícone da categoria",
  "settings.title": "Configurações",
  "settings.subtitle": "Personalize aparência, idioma, categorias e dados.",
  "settings.language": "Idioma",
  "settings.languageSection": "Idioma e região",
  "settings.datePreview": "Prévia da data",
  "settings.timePreview": "Prévia da hora",
  "settings.currencyPreview": "Prévia da moeda",
  "settings.relativePreview": "Tempo relativo",
  "settings.categories": "Categorias",
  "settings.accounts": "Contas",
  "settings.restoreDefaults": "Restaurar categorias padrão",
  "settings.restoreDefaultsConfirm":
    "Substituir todas as categorias pelo conjunto padrão (Mercado, Aluguel etc.)? Categorias personalizadas serão removidas.",
  "settings.addFirstAccount":
    "Adicione sua primeira conta para acompanhar corrente, poupança, dívidas e ativos.",
  "settings.loadDemo": "Carregar dados de demonstração",
  "settings.loadDemoDesc":
    "Apaga todos os dados e preenche 12 meses de receitas, despesas, dívidas e poupança realistas.",
  "settings.loadDemoBtn": "Carregar dados de demonstração",
  "settings.loadingDemo": "Carregando…",
  "settings.clearAll": "Apagar todos os dados",
  "settings.clearAllDesc":
    "Exclui permanentemente transações, contas, dívidas e fundos. As categorias padrão são restauradas. Não pode ser desfeito.",
  "settings.clearConfirm": "Sim, apagar tudo",
  "settings.clearing": "Apagando…",
  "settings.clearedDone":
    "Dados pessoais apagados. Categorias padrão prontas — adicione uma conta quando quiser e registre transações.",
  "settings.demoLoaded": "Dados de demonstração carregados! 12 meses de transações prontos.",
  "settings.calcCheck": "Verificação de cálculos",
  "settings.runVerification": "Executar script de verificação",
  "settings.calcCheckDesc":
    "Confirma que Dashboard, orçamento, calendário e a regra 50/30/20 ainda batem.",
  "settings.emptyAccounts": "Adicione sua primeira conta",
  "settings.categoryName": "Nome da categoria",
  "settings.accountName": "ex. Conta corrente",

  "theme.curated": "Looks selecionados",
  "theme.fineTune": "Ajustar destaque",
  "theme.corners": "Cantos",
  "theme.accent.default": "Azul oceano",
  "theme.accent.mint": "Menta pastel",
  "theme.accent.sand": "Areia quente",
  "theme.accent.midnight": "Meia-noite",
  "theme.accent.cyberpunk": "Cyberpunk",
  "theme.radius.none": "Reto",
  "theme.radius.sm": "Sutil",
  "theme.radius.md": "Padrão",
  "theme.radius.lg": "Arredondado",
  "theme.radius.full": "Pílula",
  "theme.clean": "Clean",
  "theme.cleanBlurb": "Suave e amigável",
  "theme.fintech": "Fintech",
  "theme.fintechBlurb": "Denso e preciso",
  "theme.minimal": "Minimal",
  "theme.minimalBlurb": "Editorial e calmo",
  "theme.forest": "Forest",
  "theme.forestBlurb": "Verde-água e creme quente",

  "layout.brand": "BudgetOS",
  "layout.tagline": "Planejador anual",
  "layout.collapse": "Recolher",
  "app.loading": "Carregando BudgetOS…",
  "app.newTx": "Adicionar transação",
  "app.help": "Ajuda",

  "print.tagline": "Orçamento anual e patrimônio · Gerado em {date}",
  "print.footer": "Offline-first · os dados ficam neste dispositivo",

  "nw.month": "Mês",
  "nw.totalAssets": "Ativos totais ({symbol})",
  "nw.totalDebts": "Dívidas totais ({symbol})",
  "nw.title": "Acompanhamento do patrimônio líquido",
  "nw.logMonth": "Registrar mês",
  "nw.current": "Patrimônio líquido atual",
  "nw.vsLastMonth": "vs mês anterior",
  "nw.assets": "Ativos",
  "nw.debts": "Dívidas",
  "nw.debtRatio": "Índice de endividamento",
  "nw.monthsTracked": "Meses registrados",
  "nw.logForm": "Registrar patrimônio líquido",
  "nw.trend": "Tendência do patrimônio líquido",
  "nw.accounts": "Detalhamento das contas",
  "nw.saveLog": "Salvar registro",
  "nw.netWorth": "Patrimônio líquido",

  "common.noData": "Nenhum dado encontrado",
  "common.add": "Adicionar",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.delete": "Excluir",
  "common.edit": "Editar",
  "common.close": "Fechar",
  "common.export": "Exportar",
  "common.all": "Todos",
  "common.person": "Pessoa",
  "common.year": "Ano",
  "common.loading": "Carregando…",
  "common.newTransaction": "Nova transação",
  "common.uncategorized": "Sem categoria",
  "common.mainAccount": "Conta principal",

  "currency.USD": "Dólar americano ($)",
  "currency.EUR": "Euro (€)",
  "currency.GBP": "Libra esterlina (£)",
  "currency.CAD": "Dólar canadense (CA$)",
  "currency.AUD": "Dólar australiano (A$)",
  "currency.MXN": "Peso mexicano (MX$)",
  "currency.JPY": "Iene japonês (¥)",
  "currency.CHF": "Franco suíço (CHF)",
  "currency.BRL": "Real brasileiro (R$)",
  "currency.INR": "Rúpia indiana (₹)",

  "palette.mint": "Menta",
  "palette.sky": "Céu",
  "palette.coral": "Coral",
  "palette.lemon": "Limão",
  "palette.lavender": "Lavanda",

  // —— non-ui ——
  "nav.group.setup": "Configure uma vez",
  "nav.group.daily": "Uso diário",
  "nav.group.where": "Onde você está",
  "nav.group.wealth": "Construa patrimônio",
  "nav.dashboard": "Painel",
  "nav.monthly": "Orçamento mensal",
  "nav.transactions": "Transações",
  "nav.calendar": "Calendário de gastos",
  "nav.rule503020": "Regra 50/30/20",
  "nav.networth": "Patrimônio líquido",
  "nav.debt": "Quitação de dívidas",
  "nav.sinking": "Fundos objetivo",
  "nav.settings": "Configurações",
  "nav.bottom.home": "Início",
  "nav.bottom.log": "Registro",
  "nav.bottom.budget": "Orçamento",
  "nav.bottom.debt": "Dívidas",
  "nav.bottom.wealth": "Patrimônio",

  "group.income": "Receitas",
  "group.needs": "Necessidades",
  "group.wants": "Desejos",
  "group.savings": "Poupança",

  "accountType.checking": "Corrente",
  "accountType.savings": "Poupança",
  "accountType.asset": "Ativo",
  "accountType.debt": "Dívida",

  "cat.cat-sal": "Salário",
  "cat.cat-side": "Renda extra",
  "cat.cat-div": "Dividendos",
  "cat.cat-rent": "Aluguel / Hipoteca",
  "cat.cat-util": "Contas",
  "cat.cat-groc": "Mercado",
  "cat.cat-ins": "Seguros",
  "cat.cat-trans": "Transporte",
  "cat.cat-health": "Saúde",
  "cat.cat-eat": "Restaurantes",
  "cat.cat-ent": "Entretenimento",
  "cat.cat-shop": "Compras",
  "cat.cat-sub": "Assinaturas",
  "cat.cat-travel": "Viagens",
  "cat.cat-emerg": "Fundo de emergência",
  "cat.cat-invest": "Investimentos",
  "cat.cat-ret": "Aposentadoria (401k)",

  "demo.acc-check": "Conta corrente Chase",
  "demo.acc-sav": "Poupança HYSA",
  "demo.acc-cc1": "Cartão Visa",
  "demo.acc-car": "Financiamento do carro",
  "demo.acc-inv": "Corretora",
  "demo.acc-401k": "401(k)",
  "demo.dbt-cc": "Cartão Visa",
  "demo.dbt-car": "Financiamento do carro",
  "demo.dbt-sl": "Empréstimo estudantil",
  "demo.sf-hol": "Viagem de férias",
  "demo.sf-emg": "Fundo de emergência",
  "demo.sf-car": "Entrada carro novo",
  "demo.sf-home": "Reparos da casa",
  "demo.sf-tech": "Notebook novo",
  "demo.note.overDining": "Jantar com amigos",
  "demo.note.workLunch": "Almoço de trabalho",
  "demo.note.weekendOut": "Saída de fim de semana",

  "qs.unzip.title": "Antes de comecar: descompacte a pasta",
  "qs.unzip.windows":
    "Windows: clique com o botao direito no arquivo .zip -> \"Extrair tudo\" -> escolha onde salvar.",
  "qs.unzip.mac":
    "Mac: clique duas vezes no arquivo .zip - ele e descompactado automaticamente ao lado do zip original.",
  "qs.unzip.open":
    "Abra a pasta criada (mesmo nome do zip). Dentro dela esta o index.html, este guia e uma pasta chamada assets.",
  "qs.unzip.warn":
    "Nao mova nem renomeie o index.html separadamente, nem o retire dessa pasta - ele precisa ficar junto da pasta assets para funcionar.",

  "demo.banner":
    "Esta é uma demo ao vivo do BudgetOS — dados de exemplo, reinicia a cada visita.",
  "demo.readOnly":
    "Esta é uma demo de pré-visualização. As alterações não são guardadas — obtenha a versão completa na Etsy para o seu orçamento.",
  "demo.cta": "Obter a versão completa",
  "demo.ctaHint": "Defina VITE_ETSY_URL para ligar este botão ao seu anúncio na Etsy.",

  "help.title": "Ajuda e FAQ",
  "help.close": "Fechar ajuda",
  "help.replayTour": "Repetir tour de início rápido",
  "help.quickStart": "Abrir guia de início rápido (PDF)",
  "help.quickStartHtml": "Abrir versão HTML",
  "help.q0": "Como funcionam backup e restauração?",
  "help.a0":
    "Configurações → Backup e restauração baixa um JSON com todas as categorias, transações, dívidas e fundos. Importe esse arquivo no mesmo ou em outro navegador para restaurar os totais. Faça backup com frequência — esse arquivo é sua única cópia portátil.",
  "help.q1": "Como transferir dados para outro dispositivo ou navegador?",
  "help.a1":
    "Exporte um backup no dispositivo antigo, abra o BudgetOS no novo e Importe o backup. Faça isso antes de limpar dados do site ou trocar de navegador.",
  "help.q2": "Como redefinir todos os dados?",
  "help.a2":
    "Configurações → Apagar todos os dados exclui permanentemente transações, contas, dívidas e fundos e restaura as categorias padrão. Contas não são recriadas. Atualizar a página não traz a demo de volta, a menos que você toque em Carregar dados de demonstração. Só categorias: Restaurar categorias padrão.",
  "help.q3": "Como alterar moeda ou idioma?",
  "help.a3":
    "Configurações → Moeda para formatação. Configurações → Idioma e região para o idioma do app. Os valores armazenados não mudam.",
  "help.q4": "Tudo funciona offline?",
  "help.a4":
    "Sim. Depois de carregar o app, o BudgetOS não precisa de internet. Gráficos, dívidas, exportações e backups rodam localmente.",
  "help.q5": "Quais navegadores são suportados?",
  "help.a5":
    "Chrome, Firefox, Edge e Safari atuais. Use um navegador moderno com IndexedDB. Modo anônimo pode apagar dados ao fechar.",
  "help.q6": "Importante: não mova o arquivo HTML depois de salvar dados",
  "help.a6":
    "Se você abrir o BudgetOS via file:// (comum em downloads da Etsy), alguns navegadores — especialmente o Safari — vinculam o armazenamento a esse caminho. Exporte um backup antes de renomear ou mover o arquivo e importe de novo depois.",
  "help.q7": "O PDF mostra URL ou data na margem — é um bug?",
  "help.a7":
    "O relatório anual e os PDFs por seção são gerados offline com jsPDF (não o diálogo Imprimir do navegador), com cabeçalhos BudgetOS, números de página e gráficos. Se ainda usar Imprimir do navegador, desative cabeçalhos/rodapés no diálogo.",

  "tour.skip": "Pular",
  "tour.back": "Voltar",
  "tour.next": "Próximo",
  "tour.done": "Começar",
  "tour.step": "Passo {n} de {total}",
  "tour.choice.eyebrow": "Bem-vindo",
  "tour.choice.title": "Como quer começar?",
  "tour.choice.body":
    "Escolha uma vez. Depois pode carregar ou apagar a demo em Configurações.",
  "tour.choice.sample": "Explorar com dados de exemplo",
  "tour.choice.sampleDesc": "Carrega um ano realista de demonstração para explorar a app.",
  "tour.choice.empty": "Começar com os meus dados",
  "tour.choice.emptyDesc": "App vazia — só categorias predefinidas. Adicione a primeira transação quando quiser.",
  "tour.s0.title": "Seus dados ficam neste dispositivo",
  "tour.s0.body":
    "BudgetOS é offline-first. Tudo fica neste navegador — sem conta, sem nuvem, sem rastreamento.",
  "tour.s1.title": "Adicione uma transação a qualquer momento",
  "tour.s1.body":
    "Toque em + (ou Transações → Adicionar) para registrar receita ou gasto. Os totais atualizam na hora.",
  "tour.s2.title": "Configurações e backups",
  "tour.s2.body":
    "Abra Configurações para mudar moeda, tema, categorias e baixar um backup JSON. Exporte antes de trocar de navegador.",
  "tour.s3.title": "Experimente a demo quando quiser",
  "tour.s3.body":
    "Configurações → Carregar dados de demonstração preenche um ano realista. Apagar todos os dados remove-a quando quiser os seus números.",
  "tour.s4.title": "A ajuda está sempre aqui",
  "tour.s4.body": "Reabra este tour ou o FAQ pelo botão ?. Você já pode orçar.",

  "empty.accounts.networth":
    "Adicione sua primeira conta em Configurações para ver saldos aqui.",
  "empty.debts":
    "Ainda não há dívidas. Carregue a demo ou adicione dívidas ao configurar contas — esta tela fica pronta.",
  "empty.tx.noAccount":
    "Ainda não há contas — você ainda pode salvar. Adicione a primeira conta em Configurações quando quiser.",

  "dash.yearGlance": "O ano em um relance — {year}",
  "dash.downloadReport": "Baixar relatório anual",
  "dash.buildingPdf": "Gerando PDF…",
  "dash.savingsGoal": "Progresso da meta de poupança",
  "dash.savingsRateTarget": "Taxa de poupança · Meta 20%",
  "dash.rateVsTarget": "Taxa vs meta 20%",
  "dash.monthHighlights": "Destaques do mês",
  "dash.kpi.moneyIn": "Entradas",
  "dash.kpi.moneyOut": "Saídas",
  "dash.kpi.leftover": "Sobra",
  "dash.kpi.savingsRate": "Taxa de poupança",
  "dash.kpi.totalSaved": "Total poupado",

  "pdf.tagline": "Planejador anual offline",
  "pdf.cover.disclaimer":
    "Os números coincidem com os cálculos do BudgetOS na tela. Gerado totalmente offline.",
  "pdf.generated": "Gerado em {date}",
  "pdf.page": "Página {n} de {total}",
  "pdf.view": "Visão: {person}",
  "pdf.title.annual": "Relatório anual {year}",
  "pdf.period.detail": "Relatório anual {year} · detalhe {month}",
  "pdf.section.yearGlance": "O ano em um relance",
  "pdf.section.cashFlow": "Fluxo de caixa mensal",
  "pdf.section.budget": "Orçamento mensal — {month} {year}",
  "pdf.section.rule": "Distribuição 50/30/20",
  "pdf.section.debts": "Resumo de dívidas",
  "pdf.section.funds": "Fundos objetivo",
  "pdf.section.netWorth": "Patrimônio líquido",
  "pdf.col.kpi": "KPI",
  "pdf.col.value": "Valor",
  "pdf.col.month": "Mês",
  "pdf.col.in": "Entrada",
  "pdf.col.out": "Saída",
  "pdf.col.leftover": "Sobra",
  "pdf.col.category": "Categoria",
  "pdf.col.target": "Meta",
  "pdf.col.actual": "Real",
  "pdf.col.variance": "Variação",
  "pdf.col.group": "Grupo",
  "pdf.col.bucket": "Grupo",
  "pdf.col.amount": "Valor",
  "pdf.col.pctIncome": "% da renda",
  "pdf.col.targetPct": "% meta",
  "pdf.col.debt": "Dívida",
  "pdf.col.balance": "Saldo",
  "pdf.col.apr": "Taxa",
  "pdf.col.interest": "Juros",
  "pdf.col.months": "Meses",
  "pdf.col.payoff": "Quitação",
  "pdf.col.fund": "Fundo",
  "pdf.col.saved": "Poupado",
  "pdf.col.progress": "Progresso",
  "pdf.col.moNeeded": "Precisa/mês",
  "pdf.col.assets": "Ativos",
  "pdf.col.debts": "Dívidas",
  "pdf.col.net": "Líquido",
  "pdf.col.account": "Conta",
  "pdf.col.type": "Tipo",
  "pdf.col.payment": "Pagamento",
  "pdf.col.principal": "Principal",
  "pdf.sub.incomeSources": "Fontes de receita",
  "pdf.sub.nws": "Necessidades / Desejos / Poupança",
  "pdf.sub.expenseCats": "Categorias de despesa",
  "pdf.sub.accounts": "Detalhamento das contas",
  "pdf.kpi.moneyIn": "Entradas",
  "pdf.kpi.moneyOut": "Saídas",
  "pdf.kpi.leftover": "Sobra",
  "pdf.kpi.savingsRate": "Taxa de poupança",
  "pdf.kpi.totalSaved": "Total poupado",
  "pdf.savingsGoal": "Meta de poupança: {actual} / {target}",
  "pdf.debtSummary":
    "Dívida total {debt} · Juros totais {interest} · Livre de dívidas {date}",
  "pdf.nwSummary": "Líquido {net} · Ativos {assets} · Dívidas {debts}",
  "pdf.empty.debts": "Nenhuma dívida registrada.",
  "pdf.empty.funds": "Nenhum fundo objetivo registrado.",
  "pdf.empty.chart": "Nenhum gráfico disponível para este período.",
  "pdf.empty.rule":
    "Sem distribuição de despesas neste período — os valores reais são 0.",
  "pdf.chart.cashFlow": "Fluxo de caixa mensal",
  "pdf.chart.income": "Receitas",
  "pdf.chart.expense": "Despesas",
  "pdf.chart.rule": "50/30/20 · {month} {year}",
  "pdf.chart.netWorthTrend": "Tendência do patrimônio líquido",
  "pdf.chart.netWorth": "Patrimônio líquido",
  "pdf.chart.assets": "Ativos",
  "pdf.chart.debts": "Dívidas",
  "pdf.chart.emptySpend": "Sem gastos neste período",
  "pdf.chart.emptyHint":
    "Necessidades / Desejos / Poupança aparecem quando este mês tiver despesas.",
  "pdf.amortization": "Amortização — {name}",
  "pdf.payoffInterest": "Quitação {date} · Juros {interest}",
};
